import type { PersonTimelineDirecionadaLivre } from '@/types'
import { formatDateToDisplay } from '@/utils/formatDate'
import { TimelineEmptyState } from '../person-timeline-modal'

export function DirecionadaLivreTimelineSection({
	data,
}: {
	data: PersonTimelineDirecionadaLivre
}) {
	if (data.items.length === 0) {
		return (
			<TimelineEmptyState label="Nenhuma Direcionada de resposta livre aplicada no período." />
		)
	}

	return (
		<ul className="flex flex-col gap-3">
			{data.items.map((item) => (
				<li
					key={item.id}
					className="flex flex-col gap-3 rounded-lg border border-kaefer-light-silver bg-white p-3"
				>
					<div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
						<p className="text-sm font-semibold text-kaefer-dark-grey">
							{item.quizName}
						</p>
						<span className="text-xs text-muted-foreground">
							{formatDateToDisplay(item.date)}
						</span>
					</div>

					{item.comment && (
						<p className="whitespace-pre-wrap text-xs text-muted-foreground">
							{item.comment}
						</p>
					)}

					<dl className="flex flex-col gap-2">
						{item.answers.map((answer) => (
							<div
								key={`${item.id}-${answer.question}`}
								className="rounded-md bg-muted/30 px-3 py-2"
							>
								<dt className="text-xs font-medium text-muted-foreground">
									{answer.question}
								</dt>
								<dd className="mt-0.5 whitespace-pre-wrap text-sm text-kaefer-dark-grey">
									{answer.text || '—'}
								</dd>
							</div>
						))}
					</dl>
				</li>
			))}
		</ul>
	)
}
